import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MAPDIST } from 'src/app/shared/config';

@Component({
  selector: 'app-204_newkxjjsjyjddt',
  templateUrl: './204_newkxjjsjyjddt.component.html',
  styleUrls: ['./204_newkxjjsjyjddt.component.styl']
})
export class NewKxjjsjyjddtComponent implements OnInit {

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }
  ttitle = '';

  shdata: any = [];
  otdata: any = [];


  profs: string[] = [];
  seli = 0;
  rows: any[]  = [];

  ngOnInit() {
    this.ttitle = MAPDIST.newkxjjsjyjddt.title;
    this.http.get(MAPDIST.newkxjjsjyjddt.api).toPromise().then((resp: any) => {
      const shdata = [];
      const otdata = [];
      const profs  = [];
      for (const rpitem of resp) {
        if (rpitem.place == '上海市') {
          shdata.push(rpitem);
        } else {
          otdata.push(rpitem);
          if (!profs.includes(rpitem.place)) {
            profs.push(rpitem.place);
          }
        }
      }

      this.shdata = shdata;
      this.otdata = otdata;
      this.profs  = profs;
      this.selied();
    });
  }
  preProf() {
    this.seli -= 1;
    if (this.seli === -1) { this.seli = this.profs.length - 1; }

    this.selied();
  }
  nextProf() {
    this.seli += 1;
    if (this.seli === this.profs.length) { this.seli = 0; }

    this.selied();
  }
  selied() {
    const rows = [];
    for (let i = 0; i < this.otdata.length; i++) {
      const item = this.otdata[i];
      if (this.profs[this.seli] != item.place) { continue; }

      rows.push(item);
    }
    this.rows = rows;
  }

  showFullMapEvent(i: number = -1) {
    this.router.navigateByUrl('/new/pmap/newkxjjsjyjddt/' + i);
  }

}
